import { axios, API } from './config';

export const selectableItemsAPI = {
  getAll: async (itemType = null, subCategory = null) => {
    const params = {};
    if (itemType) params.item_type = itemType;
    if (subCategory) params.sub_category = subCategory;
    const response = await axios.get(`${API}/selectable-items`, { params });
    return response.data;
  },
  
  getHorsDoeuvres: async () => {
    const response = await axios.get(`${API}/selectable-items/hors-doeuvres`);
    return response.data;
  },
  
  getLateNight: async () => {
    const response = await axios.get(`${API}/selectable-items/late-night`);
    return response.data;
  },
  
  getBar: async () => {
    const response = await axios.get(`${API}/selectable-items/bar`);
    return response.data;
  },
  
  getBuffet: async () => {
    const response = await axios.get(`${API}/selectable-items/buffet`);
    return response.data;
  },
  
  getAddons: async () => {
    const response = await axios.get(`${API}/selectable-items/addons`);
    return response.data;
  },
  
  getPlated: async () => {
    const response = await axios.get(`${API}/selectable-items/plated`);
    return response.data;
  },

  getOnTheTurn: async () => {
    const response = await axios.get(`${API}/selectable-items/on-the-turn`);
    return response.data;
  },

  create: async (itemData) => {
    const response = await axios.post(`${API}/selectable-items`, itemData);
    return response.data;
  },

  update: async (itemId, itemData) => {
    const response = await axios.put(`${API}/selectable-items/${itemId}`, itemData);
    return response.data;
  },

  delete: async (itemId) => {
    const response = await axios.delete(`${API}/selectable-items/${itemId}`);
    return response.data;
  }
};
